/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIMarkReadResponse
 */
export interface APIMarkReadResponse {
    /**
     * 
     * @type {string}
     * @memberof APIMarkReadResponse
     */
    status: string;
}

/**
 * Check if a given object implements the APIMarkReadResponse interface.
 */
export function instanceOfAPIMarkReadResponse(value: object): value is APIMarkReadResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function APIMarkReadResponseFromJSON(json: any): APIMarkReadResponse {
    return APIMarkReadResponseFromJSONTyped(json, false);
}

export function APIMarkReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMarkReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function APIMarkReadResponseToJSON(value?: APIMarkReadResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
    };
}

